import { useState } from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';
import { useTheme } from 'styled-components';

import { useTranslation } from 'react-i18next';

import { Log } from '../../../types/apiResponseTypes';
import * as s from './styles';

import { frontendNotification } from '../../../components/Notification';
import { systemLogsApi } from '../../../services/requests';
import ContentContainer from '../../../templates/Content/ContentContainer';


import AsyncTable, { Column } from '../../../components/AsyncTable';
import ViewLog from '../../../components/ViewLog';
import getGenericRequestPageForAsyncTable from '../../../utils/TablesFunctions';

const SystemLogs = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [viewLog, setViewLog] = useState(false);

  const [logs, setLogs] = useState([]);
  const [logSelected, setLogSelected] = useState<Log | Record<string, never>>({});

  const handleTableViewBtn = (row: Log) => {
    setLogSelected(row);
    setViewLog(true);
  };
  const handleTableCopyBtn = (row: Log) => {
    navigator.clipboard.writeText(JSON.stringify(row));
    frontendNotification({
      message: 'Copiado com sucesso',
      type: 'success',
    });
  };

  const actionsButtons = (row: Log) => (
    <s.ActionButtonsContainer>
      <s.RiEyeLineIcon onClick={() => handleTableViewBtn(row)} />
      <s.MdFileCopyIcon onClick={() => handleTableCopyBtn(row)} />
    </s.ActionButtonsContainer>
  );

  const typeJSX = (row: Log) =>
    row.is_error ? (
      <RiErrorWarningFill style={{ color: theme.colors.negative }} />
    ) : (
      <p>
        <RiErrorWarningFill style={{ color: theme.colors.warning }} />
      </p>
    );

  const columns: Column<Log>[] = [
    {
      label: t('type') as string,
      accessor: 'is_error',
      Cell: typeJSX,
    },
    {
      label: t('id') as string,
      accessor: 'id',
    },
    {
      label: t('user') as string,
      accessor: 'userName',
    },
    {
      label: t('tenant') as string,
      accessor: 'tenantName',
    },
    {
      label: t('message') as string,
      accessor: 'message',
    },
    {
      label: t('createdAt') as string,
      accessor: 'created_at',
    },
    {
      Cell: actionsButtons,
    },
  ];

  return (
    <ContentContainer title={t('companies')}>
      <AsyncTable
        tableName={t('logs')}
        columns={columns}
        value={logs}
        onChange={setLogs}
        requestPage={getGenericRequestPageForAsyncTable(systemLogsApi)}
        reqListener={[]}
        options={{
          styles: {
            primaryColor: `${theme.colors.surface}`,
            secondaryColor: `${theme.colors.onSurface}`,
            alternateRowColor: theme.colors.onSurfaceLight,
            textColor: theme.colors.text,
          },
          quantityPerPageLabel: t('quantityPerPage'),
          searchPlaceholder: t('search'),
        }}
      />

      {viewLog && (
        <ViewLog
          showModal={viewLog}
          closeModal={() => setViewLog(false)}
          log={JSON.stringify(logSelected, null, 2)}
        />
      )}
    </ContentContainer>
  );
};

export default SystemLogs;
